import { render, staticRenderFns } from "./activate-warranty.vue?vue&type=template&id=390fd9e4&"
import script from "./activate-warranty.vue?vue&type=script&lang=ts&"
export * from "./activate-warranty.vue?vue&type=script&lang=ts&"
import style0 from "./activate-warranty.vue?vue&type=style&index=0&id=390fd9e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports